// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Login_login-container__NwzDv {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #0467a0 0%, #035a8a 50%, #ff0000 100%);
  padding: 20px;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}

.Login_login-card__IpSuF {
  background: white;
  border-radius: 20px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  padding: 40px;
  width: 100%;
  max-width: 400px;
  animation: Login_slideUp__v1Upz 0.6s ease-out;
}

@keyframes Login_slideUp__v1Upz {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.Login_login-header__SJ\\+pC {
  text-align: center;
  margin-bottom: 30px;
}

.Login_login-header__SJ\\+pC h2 {
  color: #2c3e50;
  margin: 0 0 10px 0;
  font-size: 1.8rem;
  font-weight: 700;
}

.Login_login-header__SJ\\+pC h3 {
  color: #2c3e50;
  margin: 0 0 8px 0;
  font-size: 0.8rem;
  font-weight: 600;
}

.Login_login-header__SJ\\+pC p {
  color: #7f8c8d;
  margin: 0;
  font-size: 0.95rem;
}

.Login_logo-container__e8TeQ {
  display: flex;
  justify-content: center;
  margin: 20px 0;
}

.Login_login-logo__a\\+83V {
  width: 120px;
  height: 120px;
  object-fit: contain;
  border-radius: 50%;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: transform 0.3s ease;
}

.Login_login-logo__a\\+83V:hover {
  transform: scale(1.05);
}

.Login_login-form__R0uz- {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.Login_error-message__piD7D {
  background: #fee;
  color: #c53030;
  padding: 12px;
  border-radius: 8px;
  border: 1px solid #fed7d7;
  font-size: 0.9rem;
  text-align: center;
}

.Login_form-group__ONFjv {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.Login_form-group__ONFjv label {
  color: #2c3e50;
  font-weight: 600;
  font-size: 0.9rem;
  margin-bottom: 4px;
}

.Login_form-group__ONFjv input {
  padding: 12px 16px;
  border: 2px solid #e2e8f0;
  border-radius: 10px;
  font-size: 1rem;
  transition: all 0.3s ease;
  background: #f8fafc;
}

.Login_form-group__ONFjv input:focus {
  outline: none;
  border-color: #0467a0;
  background: white;
  box-shadow: 0 0 0 3px rgba(4, 103, 160, 0.1);
}

.Login_form-group__ONFjv input::placeholder {
  color: #a0aec0;
}

.Login_login-button__Q27AJ {
  background: linear-gradient(135deg, #0467a0 0%, #035a8a 100%);
  color: white;
  border: none;
  padding: 14px 20px;
  border-radius: 10px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 10px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.Login_login-button__Q27AJ:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 10px 20px rgba(4, 103, 160, 0.3);
}

.Login_login-button__Q27AJ:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  transform: none;
}

.Login_login-button__Q27AJ:active:not(:disabled) {
  transform: translateY(0);
}

.Login_footer__oF4bg {
  text-align: center;
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #e2e8f0;
}

.Login_footer__oF4bg p {
  color: #7f8c8d;
  font-size: 0.75rem;
  margin: 0;
  font-weight: 400;
}

/* Responsive design */
@media (max-width: 480px) {
  .Login_login-card__IpSuF {
    padding: 30px 20px;
    margin: 10px;
  }
  .Login_login-header__SJ\\+pC h2 {
    font-size: 1.5rem;
  }
  .Login_login-header__SJ\\+pC h3 {
    font-size: 0.7rem;
  }
  .Login_login-logo__a\\+83V {
    width: 90px;
    height: 90px;
  }
}
/* Loading animation */
.Login_login-button__Q27AJ:disabled::after {
  content: "";
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 2px solid transparent;
  border-top: 2px solid white;
  border-radius: 50%;
  animation: Login_spin__RQX99 1s linear infinite;
  margin-left: 8px;
}

@keyframes Login_spin__RQX99 {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/auth/Login.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,0EAAA;EACA,aAAA;EACA,4DAAA;AACF;;AAEA;EACE,iBAAA;EACA,mBAAA;EACA,0CAAA;EACA,aAAA;EACA,WAAA;EACA,gBAAA;EACA,6CAAA;AACF;;AAEA;EACE;IACE,UAAA;IACA,2BAAA;EACF;EACA;IACE,UAAA;IACA,wBAAA;EACF;AACF;AAEA;EACE,kBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;AAAF;;AAGA;EACE,cAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;AAAF;;AAGA;EACE,cAAA;EACA,SAAA;EACA,kBAAA;AAAF;;AAGA;EACE,aAAA;EACA,uBAAA;EACA,cAAA;AAAF;;AAGA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,0CAAA;EACA,+BAAA;AAAF;;AAGA;EACE,sBAAA;AAAF;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAAF;;AAGA;EACE,gBAAA;EACA,cAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;AAAF;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAAF;;AAGA;EACE,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AAAF;;AAGA;EACE,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,aAAA;EACA,qBAAA;EACA,iBAAA;EACA,4CAAA;AAAF;;AAGA;EACE,cAAA;AAAF;;AAGA;EACE,6DAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;AAAF;;AAGA;EACE,2BAAA;EACA,8CAAA;AAAF;;AAGA;EACE,YAAA;EACA,mBAAA;EACA,eAAA;AAAF;;AAGA;EACE,wBAAA;AAAF;;AAGA;EACE,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,6BAAA;AAAF;;AAGA;EACE,cAAA;EACA,kBAAA;EACA,SAAA;EACA,gBAAA;AAAF;;AAGA,sBAAA;AACA;EACE;IACE,kBAAA;IACA,YAAA;EAAF;EAGA;IACE,iBAAA;EADF;EAIA;IACE,iBAAA;EAFF;EAKA;IACE,WAAA;IACA,YAAA;EAHF;AACF;AAMA,sBAAA;AACA;EACE,WAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,6BAAA;EACA,2BAAA;EACA,kBAAA;EACA,+CAAA;EACA,gBAAA;AAJF;;AAOA;EACE;IAAK,uBAAA;EAHL;EAIA;IAAO,yBAAA;EADP;AACF","sourcesContent":[".login-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  background: linear-gradient(135deg, #0467a0 0%, #035a8a 50%, #ff0000 100%);\n  padding: 20px;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n}\n\n.login-card {\n  background: white;\n  border-radius: 20px;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);\n  padding: 40px;\n  width: 100%;\n  max-width: 400px;\n  animation: slideUp 0.6s ease-out;\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.login-header {\n  text-align: center;\n  margin-bottom: 30px;\n}\n\n.login-header h2 {\n  color: #2c3e50;\n  margin: 0 0 10px 0;\n  font-size: 1.8rem;\n  font-weight: 700;\n}\n\n.login-header h3 {\n  color: #2c3e50;\n  margin: 0 0 8px 0;\n  font-size: 0.8rem;\n  font-weight: 600;\n}\n\n.login-header p {\n  color: #7f8c8d;\n  margin: 0;\n  font-size: 0.95rem;\n}\n\n.logo-container {\n  display: flex;\n  justify-content: center;\n  margin: 20px 0;\n}\n\n.login-logo {\n  width: 120px;\n  height: 120px;\n  object-fit: contain;\n  border-radius: 50%;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  transition: transform 0.3s ease;\n}\n\n.login-logo:hover {\n  transform: scale(1.05);\n}\n\n.login-form {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.error-message {\n  background: #fee;\n  color: #c53030;\n  padding: 12px;\n  border-radius: 8px;\n  border: 1px solid #fed7d7;\n  font-size: 0.9rem;\n  text-align: center;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.form-group label {\n  color: #2c3e50;\n  font-weight: 600;\n  font-size: 0.9rem;\n  margin-bottom: 4px;\n}\n\n.form-group input {\n  padding: 12px 16px;\n  border: 2px solid #e2e8f0;\n  border-radius: 10px;\n  font-size: 1rem;\n  transition: all 0.3s ease;\n  background: #f8fafc;\n}\n\n.form-group input:focus {\n  outline: none;\n  border-color: #0467a0;\n  background: white;\n  box-shadow: 0 0 0 3px rgba(4, 103, 160, 0.1);\n}\n\n.form-group input::placeholder {\n  color: #a0aec0;\n}\n\n.login-button {\n  background: linear-gradient(135deg, #0467a0 0%, #035a8a 100%);\n  color: white;\n  border: none;\n  padding: 14px 20px;\n  border-radius: 10px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  margin-top: 10px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.login-button:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 10px 20px rgba(4, 103, 160, 0.3);\n}\n\n.login-button:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.login-button:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.footer {\n  text-align: center;\n  margin-top: 30px;\n  padding-top: 20px;\n  border-top: 1px solid #e2e8f0;\n}\n\n.footer p {\n  color: #7f8c8d;\n  font-size: 0.75rem;\n  margin: 0;\n  font-weight: 400;\n}\n\n/* Responsive design */\n@media (max-width: 480px) {\n  .login-card {\n    padding: 30px 20px;\n    margin: 10px;\n  }\n  \n  .login-header h2 {\n    font-size: 1.5rem;\n  }\n  \n  .login-header h3 {\n    font-size: 0.7rem;\n  }\n  \n  .login-logo {\n    width: 90px;\n    height: 90px;\n  }\n}\n\n/* Loading animation */\n.login-button:disabled::after {\n  content: '';\n  display: inline-block;\n  width: 16px;\n  height: 16px;\n  border: 2px solid transparent;\n  border-top: 2px solid white;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-left: 8px;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"login-container": `Login_login-container__NwzDv`,
	"login-card": `Login_login-card__IpSuF`,
	"slideUp": `Login_slideUp__v1Upz`,
	"login-header": `Login_login-header__SJ+pC`,
	"logo-container": `Login_logo-container__e8TeQ`,
	"login-logo": `Login_login-logo__a+83V`,
	"login-form": `Login_login-form__R0uz-`,
	"error-message": `Login_error-message__piD7D`,
	"form-group": `Login_form-group__ONFjv`,
	"login-button": `Login_login-button__Q27AJ`,
	"footer": `Login_footer__oF4bg`,
	"spin": `Login_spin__RQX99`
};
export default ___CSS_LOADER_EXPORT___;
